import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const PointBase = (
  <path
    fill='currentColor'
    d='M7.972 2c3.341-.003 6.026 2.663 6.028 5.986C14.002 11.313 11.33 14 8.018 14 4.681 14.001 2 11.33 2 8.005c0-3.257 2.576-5.906 5.796-6.002L7.972 2zm4.638 6.727l-.754.445c-.955.565-1.757 1.363-2.64 2.568l-.178.247-.458.646c2.009-.243 3.617-1.764 4-3.736l.03-.17zM3.376 8.64c.271 2.007 1.81 3.597 3.798 3.952l-.4-.752c-.415-.78-.951-1.35-2.03-2.186l-.36-.273-.389-.288-.619-.453zm4.61-3.832l-.17.243c-1.013 1.424-1.892 2.32-3.034 2.965l.419.31.195.148.364.282c1.04.824 1.632 1.458 2.112 2.313l.079.145.185-.257c.922-1.259 1.791-2.146 2.831-2.805l.21-.129-.184-.11c-1.03-.638-1.837-1.487-2.83-2.857l-.177-.248zM8.6 3.373l.472.665c.98 1.382 1.712 2.177 2.62 2.741l.154.092.772.448c-.295-2.061-1.933-3.675-4.018-3.946zm-1.243.002C5.324 3.647 3.707 5.24 3.39 7.273l.735-.416c.94-.532 1.695-1.3 2.603-2.577l.63-.905z'
  />
)

export const Point = createIcon({
  displayName: 'Point',
  viewBox: '0 0 16 16',
  path: PointBase,
})
